export default __webpack_public_path__ + "static/media/Hurray.4da82500.png";